import axios from 'axios';
import Constants from '../constants/constants';
import RefreshTokens from '../model/RefreshToken';
import Token from '../model/Token';

export const API_URL = `${Constants.ServerProtocol}://${Constants.ServerDomain}${Constants.ApiBasePath}/`;
const $api = axios.create({
  withCredentials: true,
  baseURL: API_URL,
});

$api.interceptors.request.use((config) => {
  if (localStorage.getItem('token') !== null) {
    config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
  }
  return config;
});

$api.interceptors.response.use(
  (config) => {
    return config;
  },
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response.status == 401 &&
      error.config &&
      originalRequest._isRetry !== true
    ) {
      originalRequest._isRetry = true;
      try {
        const token = localStorage.getItem('refresh_token');
        if (token !== null) {
          const data: RefreshTokens = {
            refresh_token: token as string,
          };

          const newData = Object.entries(data)
            .map(
              (x) =>
                `${encodeURIComponent(x[0])}=${encodeURIComponent(
                  x[1] as string
                )}`
            )
            .join('&');
          const response = await axios.post<Token>(
            API_URL + 'token/refresh',
            newData,
            { withCredentials: true }
          );
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('refresh_token', response.data.refresh_token);
          return $api.request(originalRequest);
        }
      } catch (e) {}
    }

    if (
      error.response.status == 401 &&
      error.config &&
      originalRequest._isRetry === true
    ) {
      localStorage.removeItem('token');
      localStorage.removeItem('refresh_token');
    }

    throw error;
  }
);

export default $api;
